import React from "react";
import Button from "./Button";

function ToolbarTooltipButton({
  label,
  onClick,
  disabled,
  children,
  className = "",
  wrapperClassName = "relative inline-flex",
  noButton = false,
  variant = "icon",
  showLabel = false,
  tooltip = "",
  highlight = false,
  badge = "",
  active,
}) {
  const [open, setOpen] = React.useState(false);
  const wrapperRef = React.useRef(null);
  const tooltipId = React.useId();
  const isTouchDevice =
    typeof window !== "undefined" &&
    ("ontouchstart" in window || navigator.maxTouchPoints > 0);

  React.useEffect(() => {
    function handleOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("touchstart", handleOutside);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
    };
  }, []);

  const handleMouseEnter = () => { if (!isTouchDevice) setOpen(true); };
  const handleMouseLeave = () => { if (!isTouchDevice) setOpen(false); };
  const handleFocus = () => { if (!isTouchDevice) setOpen(true); };
  const handleBlur = () => { if (!isTouchDevice) setOpen(false); };
  
  const handleClick = (e) => {
    onClick?.(e);
    if (isTouchDevice) {
      setOpen(true);
      setTimeout(() => setOpen(false), 1500);
    }
  };

  return (
    <div ref={wrapperRef} className={wrapperClassName}>
      {noButton ? (
        <div className={`w-full ${className}`}>{children}</div>
      ) : (
        <Button
          variant={showLabel && variant === "icon" ? (active ? "iconTextActive" : "iconText") : variant}
          disabled={disabled}
          aria-label={tooltip || label}
          aria-pressed={active}
          aria-describedby={open ? tooltipId : undefined}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onClick={handleClick}
          className={`mt-2 ${highlight ? "u-highlight" : ""} ${className}`}
        >
          {children}
          {showLabel && <span className="whitespace-nowrap">{label}</span>}
          {active !== undefined && (
            <span className={`text-xs font-black px-1.5 py-0.5 rounded ${active ? "bg-black-0 text-black-800" : "bg-black-30 text-black-600"}`}>
              {active ? "ON" : "OFF"}
            </span>
          )}
        </Button>
      )}

      {badge && <span className="u-badge-new" aria-hidden="true">{badge}</span>}

      {open && (
        <div
          id={tooltipId}
          role="tooltip"
          className="absolute top-full mt-1 left-1/2 -translate-x-1/2 px-2 py-1 text-xs text-white bg-gray-800 rounded shadow-lg whitespace-nowrap z-50 font-bold uppercase pointer-events-none"
        >
          <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-gray-800 rotate-45" />
          {tooltip || label}
        </div>
      )}
    </div>
  );
}

export default ToolbarTooltipButton;